import { createAction } from '@reduxjs/toolkit'

/**
 * Скан товара в подбор ценников: тот же скан склада, что и в обходе
 * (`Inventory_Scan`) — имя и цена ИМЕННО выбранного склада этой базы. Своего
 * запроса у ценников нет намеренно: один вопрос к 1С — один ответ.
 */
export const priceTagScanRequested = createAction<{ resourceId: string; barcode: string }>('onec/priceTags/scanRequested')
